import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { company } from '../data/company';
import { whatsappUrlFor, quotePath } from '../utils/contactLinks';
import './ContactUsButton.css';

// Floating "Contact Us" bubble (desktop/tablet; mobile uses the bottom action bar).
// Opens a panel with a WhatsApp button for every number plus email.
function ContactUsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const fabRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (fabRef.current && !fabRef.current.contains(e.target)) setIsOpen(false);
    };
    const handleKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [isOpen]);

  return (
    <div className="contact-us-fab" ref={fabRef} data-track-location="contact_bubble">
      <div id="contact-us-panel" className={`contact-us-panel${isOpen ? ' is-open' : ''}`} hidden={!isOpen}>
        <p className="contact-us-panel-title">Chat to us on WhatsApp</p>
        {company.phones.map((phone) => {
          const url = whatsappUrlFor(phone);
          return (
            <a
              key={phone.href}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-us-option contact-us-option-whatsapp"
            >
              <span className="contact-us-option-icon">
                <Icon name="whatsapp" size={20} />
              </span>
              <span>
                <strong>{phone.label}</strong>
                <small>{phone.number}</small>
              </span>
            </a>
          );
        })}
        <Link
          to={quotePath}
          className="contact-us-option"
          onClick={() => setIsOpen(false)}
        >
          <span className="contact-us-option-icon">
            <Icon name="mail" size={20} />
          </span>
          <span>
            <strong>Email us</strong>
            <small>{company.email}</small>
          </span>
        </Link>
      </div>

      <button
        type="button"
        className="contact-us-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls="contact-us-panel"
        aria-label={isOpen ? 'Close contact options' : 'Contact us'}
      >
        <Icon name={isOpen ? 'close' : 'whatsapp'} size={20} />
        <span className="contact-us-trigger-text">Contact Us</span>
      </button>
    </div>
  );
}

export default ContactUsButton;
